
export function initMembershipHistory() {
    let membershipHistoryContainers = document.querySelectorAll('[data-membership-history]');

    [].forEach.call(membershipHistoryContainers, (container) => {
        //accordionSetup(container);
        new MembershipHistoryAccordion(container);
    });
}


const OpenClass = "open";
export class MembershipHistoryAccordion {

    mainTrigger: HTMLButtonElement;
    mainContent: HTMLElement;

    categories: MembershipCategory[] = [];
    
    constructor(container: HTMLElement) {
        this.mainTrigger = container.querySelector('[data-history-trigger]') as HTMLButtonElement;
        this.mainContent = container.querySelector('[data-history-content]') as HTMLElement;

        this.mainTrigger.addEventListener('click', this.triggerClick);

        let categoriesContainers = container.querySelectorAll('[data-membership-category]');
        [].forEach.call(categoriesContainers, (categoryContainer) => {
            this.categories.push(new MembershipCategory(categoryContainer, this))
        })
    }

    triggerClick = () => {
        if (this.mainContent.classList.contains(OpenClass)) {
            this.mainContent.classList.remove(OpenClass);
            this.mainTrigger.classList.remove(OpenClass);

            this.categories.forEach(x => {
                x.close();
            })
        }
        else {
            this.mainContent.classList.add(OpenClass);
            this.mainTrigger.classList.add(OpenClass)
        }
    }

    handleCategoryToggle(key: string) {
        this.categories.forEach(x => {
            if (x.key === key) {
                x.open();
            }
            else {
                x.close();
            }
        });
    }
}

class MembershipCategory {
    parent: MembershipHistoryAccordion;
    key: string;
    trigger: HTMLButtonElement;
    content: HTMLElement;

    constructor(categoryContainer: HTMLElement, parent: MembershipHistoryAccordion) {
        this.parent = parent;
        this.key = categoryContainer.getAttribute('data-membership-category');
        this.trigger = categoryContainer.querySelector('[data-membership-trigger]') as HTMLButtonElement;
        this.content = categoryContainer.querySelector('[data-membership-category-content]') as HTMLElement;

        this.trigger.addEventListener('click', this.handleTrigger);
    }

    close = () => {
        if (this.content.classList.contains(OpenClass)) {
            this.content.classList.remove(OpenClass);
            this.trigger.classList.remove(OpenClass);
        }
    }

    open = () => {
        if (!this.content.classList.contains(OpenClass)) {
            this.content.classList.add(OpenClass);
            this.trigger.classList.add(OpenClass);
        }
    }

    handleTrigger = () => {
        if (!this.content.classList.contains(OpenClass)) {
            this.parent.handleCategoryToggle(this.key);
        }
        else {
            this.close();
        }
    }

}